import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { TranslationLocale } from '../../../i18n';
import { getLocaleText, getUiLocale } from '../../../utils/i18n';
import { ChangeCountry } from '../ChangeCountry';

import './Footer.css';

export const Footer = memo(() => {
  // const { i18n } = useTranslation();

  // const settings = {
  //   infinite: true,
  //   slidesToShow: 10,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   speed: 2000,
  //   autoplaySpeed: 2000,
  //   arrows: false,
  //   cssEase: 'linear',
  //   draggable: false,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 8,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 4,
  //       },
  //     },
  //   ],
  // };

  // const handleLanguageChange: React.ChangeEventHandler<HTMLSelectElement> = (
  //   event,
  // ) => {
  //   onClick(event.target.value);
  // };

  return (
    <div className="footer unselectable">
      {/* First Part */}
      {/* <div className="part1">
        <img src={Icons[IconType.Gamified]} />
      </div> */}

      {/* Second Part */}
      {/* <div className="part2">
        <img src={Icons[IconType.AmCham]} />
        <p>{t('A member of The American Chamber of Commerce in Hong Kong')}</p>
      </div> */}

      {/* Third Part */}
      {/* <div className="part3">
        <h1>{t('Awards & Recommendations')}</h1>
        <div className="item">
          <p>{t('Enterprise Award')}</p>
          <div className="image-content">
            <img src={Icons[IconType.HKCT]} />
            <div className="text-content">
              <h2>{t('The Most Innovative Social Media Award')}</h2>
              <p>{t('HKCT Business Awards 2023')}</p>
            </div>
          </div>
        </div>
        <div className="item">
          <p>{t('Education Award')}</p>
          <div className="image-content">
            <img src={Icons[IconType.PCCW]} />
            <div className="text-content">
              <h2>{t('The Best Learning App')}</h2>
              <p>{t('PCCW (Yellow Page)')}</p>
            </div>
          </div>
        </div>
        <div className="item">
          <p>{t('Entertainment Award')}</p>
          <div className="image-content">
            <img src={Icons[IconType.TTPM]} />
            <div className="text-content">
              <h2>{t('Tech, Tradition Winning Team')}</h2>
              <p>{t('TTPM (Time to Play Magazine)')}</p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Fourth Part */}
      {/* <div className="part4">
        <h1>{t('Trending Users')}</h1>
        <Slider {...settings}> */}
      {/* repeat the .scrolling-item div as many times as you need */}
      {/* {TRENDING_USERS.filter((u) => u.shortlisted === true).map((user) => (
            <div key={user.name} className="scrolling-item">
              <img src={user.profileImage} />
              <p>{user.name}</p>
            </div>
          ))}
        </Slider>
      </div> */}

      {/* <div className="lang-row">
        <p
          onClick={() => onClick(TranslationLocale.EN)}
          style={getLanguageStyle(TranslationLocale.EN)}
        >
          {getLocaleText(getUiLocale(TranslationLocale.EN))}
        </p>
        <p
          onClick={() => onClick(TranslationLocale.HK)}
          style={getLanguageStyle(TranslationLocale.HK)}
        >
          {getLocaleText(getUiLocale(TranslationLocale.HK))}
        </p>
        <p
          onClick={() => onClick(TranslationLocale.TW)}
          style={getLanguageStyle(TranslationLocale.TW)}
        >
          {getLocaleText(getUiLocale(TranslationLocale.TW))}
        </p>
        <p
          onClick={() => onClick(TranslationLocale.CN)}
          style={getLanguageStyle(TranslationLocale.CN)}
        >
          {getLocaleText(getUiLocale(TranslationLocale.CN))}
        </p>
        <p
          onClick={() => onClick(TranslationLocale.JP)}
          style={getLanguageStyle(TranslationLocale.JP)}
        >
          {getLocaleText(getUiLocale(TranslationLocale.JP))}
        </p>
      </div> */}
      <LanguageRow />

      <div>
        <ChangeCountry />
      </div>

      {/* <div
        style={{
          position: 'relative',
          display: 'inline-block',
          margin: '0 10px',
          marginLeft: 'auto',
          marginBottom: 0,
          alignSelf: 'flex-end',
        }}
      >
        <select
          onChange={handleLanguageChange}
          value={i18n.language}
          style={{
            padding: '8px',
            backgroundColor: 'white',
            borderColor: '#ccc',
            borderRadius: '4px',
            fontSize: '16px',
            color: '#05656B',
            outline: 'none',
            cursor: 'pointer',
            appearance: 'none',
            paddingRight: '30px',
          }}
        >
          <option value={TranslationLocale.EN}>
            {getLocaleText(getUiLocale(TranslationLocale.EN))}
          </option>
          <option value={TranslationLocale.HK}>
            {getLocaleText(getUiLocale(TranslationLocale.HK))}
          </option>
          <option value={TranslationLocale.TW}>
            {getLocaleText(getUiLocale(TranslationLocale.TW))}
          </option>
          <option value={TranslationLocale.CN}>
            {getLocaleText(getUiLocale(TranslationLocale.CN))}
          </option>
          <option value={TranslationLocale.JP}>
            {getLocaleText(getUiLocale(TranslationLocale.JP))}
          </option>
        </select>
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: '#05656B',
          }}
        >
          &#x25BC;
        </span>
      </div> */}

      <div className="copyright">
        <p className="text-sm text-cyan-800">JOYAJOY</p>
        <p className="text-sm text-cyan-800">
          ©{new Date().getFullYear()} All Rights Reserved
        </p>
      </div>
    </div>
  );
});

export const LanguageRow = memo(() => {
  const { i18n } = useTranslation();
  const getLanguageStyle = (locale: string) => ({
    color: i18n.language === locale ? 'black' : '#05656B',
    cursor: 'pointer',
  });
  const onClick = useCallback(
    (locale: string) => {
      i18n.changeLanguage(locale).catch(console.error);
    },
    [i18n],
  );

  return (
    <div className="lang-row">
      <p
        onClick={() => onClick(TranslationLocale.EN)}
        style={getLanguageStyle(TranslationLocale.EN)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.EN))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.HK)}
        style={getLanguageStyle(TranslationLocale.HK)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.HK))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.TW)}
        style={getLanguageStyle(TranslationLocale.TW)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.TW))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.CN)}
        style={getLanguageStyle(TranslationLocale.CN)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.CN))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.JP)}
        style={getLanguageStyle(TranslationLocale.JP)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.JP))}
      </p>
    </div>
  );
});
